import { useSelector } from 'react-redux'
import { createSelector } from 'reselect'
import { IApplicationState } from '../../combiners'

export const useBreakpoint = () => {
  const breakpoint = useSelector(
    createSelector(
      (state: IApplicationState) => state.menu,
      ({ breakpoint }) => breakpoint
    )
  )

  return breakpoint
}
